export const ALLOWED_IMAGE_FORMATS = ['image/png', 'image/jpg', 'image/jpeg'];
export const ALLOWED_IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg'];

export const IMAGE_FILE_SIZE_LIMIT = 10485760; //10MB
